<template>
  <v-card  flat :loading="loading" :disabled="disabled">
    <v-card-title test-tag="tag-292">DaData</v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col>
          <TextField 
            :label="$t('API-ключ')" 
            :hint="$t('API-ключ DaData доступен в личном кабинете сервиса после регистрации учетной записи')" 
            :original_value="original_value.token" 
            v-model="dadata.token" 
            password
          />
          <ListItemsController 
            allow_create
            allow_delete
            allow_edit
            allow_sort
            
            :label="$t('Ограничения')"
            :empty_list_label="$t('Ограничения стандартизации не заданы')"
            v-model="dadata.named_restrictions"
            :original_value="original_value.named_restrictions"
          >
            <template #list-item="{ item }">
              <v-list-item-avatar><v-icon>mdi-map-marker-star</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle>{{item.region ? `${item.region} ${$t('обл.')}` : ''}} {{item.area ? `${item.area} ${$t('р-н.')}` : ''}}</v-list-item-subtitle>
                <v-list-item-title>{{item.city ? `${$t('г.')} ${item.city}` : ''}}</v-list-item-title>
              </v-list-item-content>
            </template>

            <template #dialog="{item, is_new, submit, remove}">
              <v-card>
                <v-card-title test-tag="tag-181">
                  <T :key="1" v-if="is_new">Добавление ограничения</T>
                  <T :key="2" v-else>Редактирование ограничения</T>
                </v-card-title>
                <v-form @submit.prevent="submit">
                  <v-card-text>
                    <TextField :label="$t('Область')" v-model="item.region"/>
                    <TextField :label="$t('Район')" v-model="item.area"/>
                    <TextField :label="$t('Город')" v-model="item.city"/>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn test-tag="tag-178" text color="secondary" v-if="!is_new" type="button" @click="remove"><v-icon>mdi-delete</v-icon><T>Удалить</T></v-btn>
                    <v-btn test-tag="tag-179" text color="primary" type="submit"><v-icon>mdi-check</v-icon><T>Готово</T></v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
              
            </template>
          </ListItemsController>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import TextField from '../../common/TextField.vue'
import ListItemsController from '../../common/ListItemsController.vue'

export default {
  props: ['value', 'loading', 'disabled', 'original_value'],
  computed: {
    dadata: {
      get(){
        return this.value || {}
      },
      set(v){
        this.$emit('input', v)
      }
    }
  },
  components: {
    TextField,
    ListItemsController
  }
}
</script>